/**
 * Basic Slider shared block scripts
 * This file gets shared between the
 * theme and editor.
 */
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/modules/effect-fade/effect-fade.scss'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

const sliders = document.querySelectorAll('.basic-slider__frame')

if (sliders) {
	sliders.forEach((slider) => {
		let opt = {
			speed: 400,
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				type: 'bullets',
				bulletElement: 'button',
				clickable: true,
				bulletClass: 'swiper-pagination-bullet button--basic',
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			on: {
				transitionStart() {
					if (this.slides[this.activeIndex].ani.length) {
						this.slides[this.activeIndex].ani.forEach((el) => el.classList.remove('is-shown'))
					}
				},
				transitionEnd() {
					if (this.slides[this.activeIndex].ani.length) {
						this.slides[this.activeIndex].ani.forEach((el) => el.classList.add('is-shown'))
					}
				},
			},
		}

		if (slider.dataset.autoplay) {
			opt = {
				...opt,
				autoplay: {
					delay: slider.dataset.autoplay * 1000,
					disableOnInteraction: true,
				},
			}
		}

		if (slider.dataset.effect === 'fade') {
			opt = {
				...opt,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
			}
		}

		const swiper = new Swiper(slider, opt)

		swiper.slides.forEach((slide) => {
			slide.ani = slide.querySelectorAll('.ani')
		})
	})
}
